<template>
  <div>
    <div
      class="px-8 py-4 white"
      >
      <h1
        class="mt-2"
        >
        Conexiones
      </h1>
    </div>

    <list
    ></list>
  </div>
</template>

<script>
import List from '@/components/matches/List'

export default {
  components: {
    List
  }
}
</script>
